import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiProvider } from "../ApiProvider";
import { AxiosError } from "axios";

export type TChangeSeatNumbersPayload = {
	ItemId: number;
	SeatNumber: number | string;
	IsOddEven: boolean;
};

type ChangeSeatNumbersState = {
	loading: boolean;
	error: string | null;
};

const initialState: ChangeSeatNumbersState = {
	loading: false,
	error: null,
};

const postSeatChanges = async (path: string, payload: Array<TChangeSeatNumbersPayload>) =>
	ApiProvider.default.post<Array<TChangeSeatNumbersPayload>>(path, { SeatChanges: payload });

export const changeTicketsSeatNumbers = createAsyncThunk<unknown, Array<TChangeSeatNumbersPayload>>(
	"changeSeatNumbers/changeTicketsSeatNumbers",
	async (payload, { rejectWithValue }) => {
		try {
			return await postSeatChanges("/api/Pricing/ChangeTicketsSeatNumbers", payload);
		} catch (error) {
			if (error instanceof AxiosError) return rejectWithValue(error.message);
			else return rejectWithValue("Unknown error");
		}
	},
);

export const forceChangeTicketsSeatNumbers = createAsyncThunk<unknown, Array<TChangeSeatNumbersPayload>>(
	"changeSeatNumbers/forceChangeTicketsSeatNumbers",
	async (payload, { rejectWithValue }) => {
		try {
			return await postSeatChanges("/api/Pricing/ForceChangeTicketsSeatNumbers", payload);
		} catch (error) {
			if (error instanceof AxiosError) return rejectWithValue(error.message);
			else return rejectWithValue("Unknown error");
		}
	},
);

const changeSeatNumbersSlice = createSlice({
	name: "changeSeatNumbers",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addMatcher(
				(action) => action.type.startsWith("changeSeatNumbers/") && action.type.endsWith("/pending"),
				(state) => {
					state.loading = true;
				},
			)
			.addMatcher(
				(action) => action.type.startsWith("changeSeatNumbers/") && action.type.endsWith("/fulfilled"),
				(state) => {
					state.loading = false;
					state.error = null;
				},
			)
			.addMatcher(
				(action) => action.type.startsWith("changeSeatNumbers/") && action.type.endsWith("/rejected"),
				(state, action) => {
					state.loading = false;
					state.error = `${(action as { payload?: unknown }).payload}`;
				},
			);
	},
});

export default changeSeatNumbersSlice;
